import React from 'react';
import styled from 'styled-components';

export default function FooterItem({ title, value, unit }) {
  return (
    <Root>
      <Title>{title}</Title>
      <Info className='footer-info'>{value}</Info>
      <Unit>{unit}</Unit>
    </Root>
  );
}

const Root = styled.div`
  flex: 1;
`;

const Title = styled.div`
  font-size: 12px;
  line-height: 17px;
  color: rgba(32, 43, 64, 0.5);
`;

const Info = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #202b40;
`;

const Unit = styled.span`
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: rgba(32, 43, 64, 0.5);
  padding-left: 4px;
`;
